<template>
  <section>
    <transition-group name='list' tag='ul' enter-active-class="animated bounceIn" leave-active-class="animated bounceOut" >
      <li v-for="(todoItem, index) in this.storedTodoItems" :key="todoItem.item" class="shadow" :class="{ hl : todoItem.highlight && !todoItem.completed  }">
          <i class="checkBtn fas fa-check" :class="{checkBtnCompleted : todoItem.completed}" aria-hidden="true" @click="toggleComplete({todoItem, index})"></i>
        <span :class="{textCompleted: todoItem.completed}"> {{ todoItem.item }} </span>
        <div class="btn-align">
          <span class="starBtn" type="button" @click="highlight({todoItem, index})"  v-if="!todoItem.completed">
            <i class="fa-star" :class="{ far : !todoItem.highlight, fas : todoItem.highlight }" aria-hidden="true"></i>
          </span>
          <span class="editBtn" type="button" @click="popEditModal(todoItem, index)" v-if="!todoItem.completed">
            <i class="far fa-edit" aria-hidden="true"></i>
          </span>
          <span class="removeBtn" type="button" @click="removeTodo({todoItem, index})">
            <i class="far fa-trash-alt" aria-hidden="true"></i>
          </span>
        </div>
      </li>
    </transition-group>

    <modal v-if="editModal" @close="editModal=false">
      <h3 slot="header">Edit TODO</h3>
      <span slot="body">
        <input type="text" v-model="editItem" placeholder="Edit What You Have TODO" v-on:keyup.enter="editTodo({oldItem, oldIndex, editItem}); editModal=false" onfocus="this.select()" autofocus="autofocus">
        <i class="far fa-edit" aria-hidden="true" @click="editTodo({oldItem, oldIndex, editItem}); editModal=false;"></i>
        <i class="closeModalBtn fas fa-times" aria-hidden="true" @click="editModal=false"></i>
      </span>
    </modal>

  </section>
</template>

<script>
import Modal from './common/Modal.vue'
import {mapGetters, mapMutations} from 'vuex'

export default {
  data: function() {
    return {
      editItem : "",
      editModal : false,
      oldItem : "",
      oldIndex : "",
      isFilled : false
    }
  },
  methods : {
    // editTodo(todoItem, index, editItem) {
    //   this.$store.commit('editTodo', {todoItem, index, editItem});
    // },
    popEditModal(todoItem, index) {
      this.oldItem = todoItem;        // 선택한 todo
      this.oldIndex = index;          // 선택한 todo index
      this.editItem = todoItem.item;  // 바꾸려는 todo
      this.editModal = !this.editModal;
    },
    ...mapMutations(['removeTodo','toggleComplete', 'highlight', 'editTodo']),
  },
  computed :{
    ...mapGetters(['storedTodoItems'])
  },
  components : {
    Modal
  }
}
</script>

<style scoped>
  @import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css";

  ul {
    list-style-type: none;
    padding-left: 0px;
    margin-top: 0;
    text-align: left;
  }

  li {
    display: flex;
    min-height: 50px;
    height: 50px;
    line-height: 50px;
    margin: 0.5rem 0;
    padding: 0 0.9rem;
    background: white;
    border-radius: 5px;
  }

  .hl{
    background: linear-gradient(to right, #6578FB, #8763FB);
    color : white;
  }

  .checkBtn {
    line-height: 45px;
    color : #62acde;
    margin-right: 5px;
  }

  .checkBtnCompleted {
    color : #b3adad;
  }

  .textCompleted {
    text-decoration: line-through;
    color: #b3adad;
  }

  .removeBtn {
    margin-left: 1vw;
    color: #de4343;
  }

  .editBtn {
    margin-left: 1vw;
    color : #41a233;
  }

  .starBtn {
    margin-left: auto;
    color : #fcc100;
  }

  .btn-align {
    margin-left: auto;
  }
  
  .list {
    transition : 1s;
    transform: translateX(30px);
  }

  /* .list-enter-active, .list-leave-active {
    transition: all 1s;
  }

  .list-enter, .list-leave-to {
    opacity: 0;
    transform: translateY(30px);
  } */
</style>



// WEBPACK FOOTER //
// src/components/TodoList.vue